import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {
    Box,
    Button,
    FormControl,
    Grid,
    TextField,
    Select,
    Tooltip,
} from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { useState } from "react";
import FuseAnimate from "@fuse/core/FuseAnimate";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon";
import addIcon from '../../../../assets/add-training.svg';

const useStyles = makeStyles((theme) => ({
    addButton: {
        position: "absolute",
        right: 30,
        top: 135,
        zIndex: 99,
    },
}))

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& input": {
        padding: "10px 10px !important",
        height: '0.4375em',
    },
    // ".muiltr-rboi0c-MuiInputBase-root-MuiOutlinedInput-root": {
    //     lineHeight: 1,
    //     minHeight: '30px',
    // },
    "& .MuiInputBase-root": {
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 1.5,
        minHeight: '30px',
        border: "1px solid white",
        borderRadius: "25px",
    },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    "& input": {
        padding: "10px 15px !important",
        height: "0.4375em",
    },
    "&.MuiInputBase-root": {
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: 1.5,
        minHeight: '27px',
        border: "1px solid white",
        borderRadius: "25px",
    }
}
))

const FeedbackQrFilter = (props) => {
    const classes = useStyles(props);
    const { handleCustomerCodeChange, handleYearChange, handleMonthChange, handleAddTraining, handleSummaryClick } = props;
    const [selectedCustomerCode, setSelectedCustomerCode] = useState('Customer Code');
    const viewCustomerCode = ['Customer Code', 'UAE30001', 'KUWAIT30003', 'MALDIVES30009'];
    const [selectedYear, setSelectedYear] = useState('Year');
    const viewYear = ['Year', '2024', '2025'];
    const [selectedMonth, setSelectedMonth] = useState('Month');
    const viewMonth = ['Month', 'January', 'Febraury', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <div className="flex">
                    <FormControl className="flex flex-row flex-nowrap">
                        <Grid container spacing={2} className="flex-nowrap">
                            <Grid item md={4} lg={4}>
                                <div className="mr-16">
                                    <StyledTextField type="text" variant="outlined" fullWidth name="company" value="Teritory 1" aria-readonly />
                                </div>
                            </Grid>
                            <Grid item md={6} lg={6}>
                                <div className="mr-16">
                                    <StyledSelect
                                        className="w-full rounded-8 h-2.5 overflow-hidden"
                                        value={selectedCustomerCode}
                                        name="customerCode"
                                        onChange={(e) => { setSelectedCustomerCode(e.target.value); handleCustomerCodeChange(e.target.value) }}
                                        variant="outlined"
                                    >
                                        {viewCustomerCode
                                            .map((val, index) => (
                                                <MenuItem
                                                    key={val}
                                                    value={val}
                                                    className="m-8 mt-0 rounded-lg"
                                                >
                                                    {val}
                                                </MenuItem>
                                            ))}
                                    </StyledSelect>
                                </div>
                            </Grid>
                            <Grid item md={4} lg={4}>
                                <div className="mr-16">
                                    <StyledSelect
                                        className="w-full rounded-8 h-2.5 overflow-hidden"
                                        value={selectedYear}
                                        name="year"
                                        onChange={(e) => { setSelectedYear(e.target.value); handleYearChange(e.target.value) }}
                                        variant="outlined"
                                    >
                                        {viewYear
                                            .map((val, index) => (
                                                <MenuItem
                                                    key={val}
                                                    value={val}
                                                    className="m-8 mt-0 rounded-lg"
                                                >
                                                    {val}
                                                </MenuItem>
                                            ))}
                                    </StyledSelect>
                                </div>
                            </Grid>
                            <Grid item md={4} lg={4}>
                                <div className="mr-16">
                                    <StyledSelect
                                        className="w-full rounded-8 h-2.5 overflow-hidden"
                                        value={selectedMonth}
                                        name="month"
                                        onChange={(e) => { setSelectedMonth(e.target.value); handleMonthChange(e.target.value) }}
                                        variant="outlined"
                                    >
                                        {viewMonth
                                            .map((val, index) => (
                                                <MenuItem
                                                    key={val}
                                                    value={val}
                                                    className="m-8 mt-0 rounded-lg"
                                                >
                                                    {val}
                                                </MenuItem>
                                            ))}
                                    </StyledSelect>
                                </div>
                            </Grid>
                            {!props.hideAddButton &&
                                <Grid item md={3} lg={3} className="ml-auto">
                                    <div className="mr-16 cursor-pointer">
                                        <FuseAnimate animation="transition.expandIn" delay={500}>
                                            <Tooltip title={"Add Event"}>
                                                <img src={addIcon} width={'25'} height={'auto'} alt="add icon" onClick={handleAddTraining} />
                                            </Tooltip>
                                        </FuseAnimate>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                    </FormControl>
                </div>
            </Box>
        </>
    )
}

export default FeedbackQrFilter;